import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useLogin } from "../../../context/LoginContext";
import apiClient from "../../../api/apiClient";
import { GETCERTIFICATES } from "../../../utils/ApiEndPoint";
import {formatDate} from "../../../utils/utils";
import { useCourse } from "../../../context/CourseContext";

export default function Certificates() {
    const { user } = useLogin();
    const {getcourseNameById} = useCourse();
    const [certificates, setCertificates] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        const fetchCertificates = async () => {
            try {
                setLoading(true)
                apiClient.get(`${GETCERTIFICATES}/${user.userId}?page=1&limit=10&status=issued`)
                    .then((response) => {
                        if (response.status === 200) {
                            setCertificates(response.data.items);
                        } 
                    }).catch((error) => {
                    }).finally(() => {
                        setLoading(false);
                    });
            } catch (error) {
                console.error("Error fetching certificates:", error);
            }
        }
        fetchCertificates();
    }, []);
    if (loading) return <p className='p-2 w-100 text-center m-3 bg-light'>Loading courses...</p>;
    return (
        <Row className='pt-3'>
            <Col lg={12} className='learner-rightside-widgetbox'>
                {/* <small>Achievements and Certifications</small> */}
                <h6>Achievements and Certifications </h6>
                {certificates.length === 0 && <div className='text-center'>No Certificates Found</div>}
                {certificates.length > 0 && certificates.map((certificate, index) => {
                    return (<Row key={index} className='certificate-infobox'>
                        <Col lg={4} onClick={() => window.open(certificate.certificateUrl, '_blank')} style={{ cursor: 'pointer' }}>
                            <img src={'/lms/img/certificate.jpeg'} alt='Certificate Info' width='100%'/>
                        </Col>
                        <Col lg={8}>
                            <h5>{getcourseNameById(certificate.courseId)}</h5>
                            <span className='d-block'>Issue Date : {formatDate(certificate.issueDate,false)}</span>
                        </Col>
                    </Row>);
                })}
            </Col>
        </Row>
    );
}